import axios from 'axios'
import firebase from 'firebase'

const planOptions = {
  essential_plan: {
    name: 'Essentials',
    amount: 15000
  },
  ramping_up: {
    name: 'RampingUp',
    amount: 20000
  },
  pro: {
    name: 'Pro',
    amount: 30000
  },
  extreme: {
    name: 'Extreme',
    amount: 40000
  }
}

export default {
  data () {
    return {
      plan: '',
      planOptions,
      handler: null
    }
  },
  mounted () {
    this.handler = window.StripeCheckout.configure({
      key: 'pk_live_HMdVIbE1lczPWk2NxYJkXuPu',
      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      locale: 'auto',
      token: async (token) => {
        const firebaseToken = await firebase.auth().currentUser.getIdToken(true)

        const url = 'https://qt04hf5etk.execute-api.us-east-1.amazonaws.com/dev/subWithStripe'
        await axios.post(url, {
          email: token.email,
          stripeToken: token.id,
          firebaseToken,
          plan: this.plan
        })

        this.$router.push({ name: 'Account' })
      }
    })
  },
  methods: {
    setUpStripe () {
      // Open Checkout with further options:
      this.handler.open({
        name: 'FoxBooks',
        description: planOptions[this.plan].name,
        zipCode: false,
        amount: planOptions[this.plan].amount
      })

      // Close Checkout on page navigation:
      window.addEventListener('popstate', () => {
        this.handler.close()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/stripe.js